import { render, staticRenderFns } from "./EmailSmsLogSideMenu.vue?vue&type=template&id=c16b7ae4"
import script from "./EmailSmsLogSideMenu.vue?vue&type=script&lang=js"
export * from "./EmailSmsLogSideMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports